module.exports = __webpack_public_path__ + "img/20200704_133926.d952c4dc.jpg";